import { lazy, Suspense, useState } from "react";
import { Link, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Box from "@mui/material/Box";
import Accord from "../../../../components/Accordion";
import NoResults from "../../../../components/NoResults";
import { useLanguage } from "../../../../context/LanguageContext";
import { Colors } from "../../../../styles/theme";
import platformStyles from "../Platform/Platform.styles";
import styles from "./FAQ.styles";

const FormDialog = lazy(() => import("./components/FormDialog"));

const FAQ = () => {
  const { translate, selectedLanguage } = useLanguage();
  const [openForm, setOpenForm] = useState(false);
  const FAQ = translate("faqs");
  const filteredFAQ = Array.isArray(FAQ) ? FAQ : [];


  return (
    <Box
      component="section"
      id="faq"
      sx={{ ...styles.FAQ_container, scrollMarginTop: "80px" }}
    >
      <Box sx={platformStyles.Platform_textContainer}>
        <Typography
          variant="subtitle2"
          component="p"
          color={Colors.primary}
          mb={{ xs: 1.25, sm: 2 }}
          sx={{
            fontWeight: 800,
            letterSpacing: 3,
            textAlign: "center",
            textTransform: "uppercase",
          }}
        >
          {translate("frequentlyAskedQuestions")}
        </Typography>
        <Typography
          variant="h2"
          sx={{
            color: Colors.navy,
            fontSize: { xs: "2.35rem", md: "4rem" },
            fontWeight: 800,
            letterSpacing: 0,
            lineHeight: 1.08,
            textAlign: "center",
          }}
        >
          {translate("faq section heading")}
        </Typography>
        <Typography
          variant="h6"
          component="p"
          color={Colors.text}
          mt={{ xs: 1.5, sm: 2 }}
          sx={{
            fontWeight: 500,
            lineHeight: 1.65,
            textAlign: "center",
          }}
        >
          <Box
            component="span"
            sx={{
              display: "inline-flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
              columnGap: 0.75,
              rowGap: 0.5,
              direction: selectedLanguage === "ar" ? "rtl" : "ltr",
            }}
          >
            <Box component="span">
              {translate("faq header")}
            </Box>
            <Link
              component="button"
              color={Colors.text}
              underline="hover"
              onClick={() => setOpenForm(true)}
              sx={{
                border: 0,
                padding: 0,
                font: "inherit",
                fontWeight: 700,
                verticalAlign: "baseline",
                color: Colors.primary,
                display: "inline-flex",
                alignItems: "center",
                gap: 0.5,
                direction: selectedLanguage === "ar" ? "rtl" : "ltr",
                textDecorationColor: Colors.primary,
              }}
            >
              {translate("ask us")}
              <ArrowForwardIcon
                sx={{
                  fontSize: "1.1rem",
                  transform: selectedLanguage === "ar" ? "scaleX(-1)" : "none",
                }}
              />
            </Link>
          </Box>
        </Typography>
      </Box>
      <Box sx={styles.FAQ_list}>
        {Array.isArray(filteredFAQ) && filteredFAQ.length > 0 ? (
          filteredFAQ.map((element, index) => (
            <Accord
              key={index}
              title={translate(element.question)}
              content={translate(element.answer)}
              variant="faq"
            />
          ))
        ) : (
          <NoResults />
        )}
      </Box>
      {openForm && <Suspense fallback={<p role="status">Loading…</p>}><FormDialog onClose={() => setOpenForm(false)} /></Suspense>}
    </Box>
  );
};

export default FAQ;
